// extracted by mini-css-extract-plugin
module.exports = {"Join":"_2li9eSuqW5p3SSVi2hk4aq"};